module.exports = __webpack_public_path__ + "img/book.66e28a7.webp";